import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Group, Page, PageText } from '@memorabid/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenericPageService {
  private readonly _api = inject(ApiService);
  private readonly version = 2;

  getBySlug(
    slug: string,
    idLanguage: number,
    idSeller?: number
  ): Observable<PageText> {
    return this._api.requestLocalStorageCached(
      ApiServiceHolder.genericpage.getBySlug(slug, idLanguage, idSeller),
      undefined,
      this.version
    );
  }

  getGroups(idSeller?: number): Observable<Group[]> {
    return this._api.requestLocalStorageCached(
      ApiServiceHolder.genericpage.getGroups(idSeller),
      undefined,
      this.version
    );
  }

  getHeaderPages(idSeller?: number): Observable<Page[]> {
    return this._api.requestLocalStorageCached(
      ApiServiceHolder.genericpage.getHeaderPages(idSeller),
      undefined,
      this.version
    );
  }

  getFooterPages(idSeller?: number): Observable<Page[]> {
    return this._api.requestLocalStorageCached(
      ApiServiceHolder.genericpage.getFooterPages(idSeller),
      undefined,
      this.version
    );
  }
}
